import styled from "styled-components";
import { globalTheme } from "@cld/component-theme";
import { typography } from "@cld/typography";

export const CategoriesBox = styled.div`
	padding: ${globalTheme.spacing.md} ${globalTheme.spacing.sm};
	padding-right: 0px;
	overflow: auto;
`;

export const CategoriesList = styled.ul`
	display: flex;
	list-style: none;
	flex-wrap: wrap;
	margin: 0px;
	padding: 0px;
	padding-bottom: ${globalTheme.spacing.md};
`;
export const ListItem = styled.li`
	width: 25%;
	opacity: 0.5;
	cursor: pointer;
	transition: 0.25s ease-in-out;
	:hover {
		opacity: 1;
	}
	padding-bottom: ${globalTheme.spacing.xs};
`;

export const CategoryHeader = styled.h2`
  	${typography.lg.regular};
`;

export const CategorySubheader = styled.h3`
  	${typography.md.highContrast};
	margin: 0px;
`;

export const CategoryThumbnailBox = styled.div`
	position: relative;
	height: 135px;
	width: 135px;
	cursor: pointer;
	margin-right: ${globalTheme.spacing.md};
	margin-bottom: ${globalTheme.spacing.md};
`;
export const CategoryThumbnailName = styled.div`
	width: 133px;
	position: absolute;
	bottom: 0px;
	left: 0px;
	height: 37px;
	background: rgba(0,0,0, 0.4);
	color: ${globalTheme.color.white};
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const GridBox = styled.div`
	width: 100%;
	overflow: none;
	height: ${({ isFiltersPanelOpen }) => isFiltersPanelOpen ? 184 : 198}px;
	margin-left: -7px;// hacks to make grid list looks like it should
	.scroller {
		padding-bottom: 0px !important;
		ul {
			margin-top: 0px ;
		}
	}
`;
